import { Action, createAction, handleActions } from "redux-actions";
import { GetSiniestroResponse } from "~api/types";
import {
  DetalleSiniestroState,
  Dispatch,
  GetState,
  ServicesDetalleSiniestro,
} from "../types";

const getSiniestroInited = createAction("OBTENER_SINIESTRO_INITED");

const getSiniestroCompleted = createAction(
  "OBTENER_SINIESTRO_COMPLETED",
  (currentSiniestro: GetSiniestroResponse) => ({ currentSiniestro })
);

const getSiniestroFailed = createAction(
  "OBTENER_SINIESTRO_FAILED",
  (error: unknown) => ({
    error,
  })
);

const getSiniestro = (id: string) => {
  return async (
    dispatch: Dispatch,
    getState: GetState,
    services: ServicesDetalleSiniestro
  ) => {
    try {
      dispatch(getSiniestroInited());

      const response = await services.api.siniestros().getSiniestro(id);

      dispatch(getSiniestroCompleted(response));
    } catch (error) {
      console.log(error);
      dispatch(getSiniestroFailed(error));
    }
  };
};

const postSiniestroComentarioInited = createAction(
  "POST_COMENTARIO_SINIESTRO_INITED"
);

const postSiniestroComentarioCompleted = createAction(
  "POST_COMENTARIO_SINIESTRO_COMPLETED"
);

const postSiniestroComentarioFailed = createAction(
  "POST_COMENTARIO_SINIESTRO_FAILED",
  (error: unknown) => ({
    error,
  })
);

const closeSuccessComentarioPopUp = createAction(
  "CLOSE_SUCCESS_COMENTARIO_POPUP"
);

const postSiniestroComentario = (siniestroId: string, comentario: string) => {
  return async (
    dispatch: Dispatch,
    getState: GetState,
    services: ServicesDetalleSiniestro
  ) => {
    try {
      dispatch(postSiniestroComentarioInited());

      const data = {
        contenidoComentario: comentario,
      };

      await services.api
        .siniestros()
        .postSiniestroComentario(siniestroId, data);

      dispatch(postSiniestroComentarioCompleted());
    } catch (error) {
      console.log(error);
      dispatch(postSiniestroComentarioFailed(error));
    }
  };
};

const clearData = createAction("CLEAR_DATA_SINISTRO", () => ({}));

const detalleSiniestroReducerInitialState: DetalleSiniestroState = {
  isLoading: false,
  currentSiniestro: null,
  failed: false,
  comentarioNuevo: false,
};

const detalleSiniestroReducer = handleActions<DetalleSiniestroState, any>(
  {
    [clearData.toString()]: (): DetalleSiniestroState => {
      return {
        ...detalleSiniestroReducerInitialState,
      };
    },
    [getSiniestroInited.toString()]: (
      state: DetalleSiniestroState
    ): DetalleSiniestroState => {
      return {
        ...state,
        isLoading: true,
      };
    },
    [getSiniestroCompleted.toString()]: (
      state: DetalleSiniestroState,
      action: Action<{ currentSiniestro: GetSiniestroResponse }>
    ): DetalleSiniestroState => {
      return {
        ...state,
        currentSiniestro: action.payload.currentSiniestro,
        isLoading: false,
        failed: false,
      };
    },
    [getSiniestroFailed.toString()]: (
      state: DetalleSiniestroState
    ): DetalleSiniestroState => {
      return {
        ...state,
        isLoading: false,
        failed: true,
      };
    },
    [postSiniestroComentarioInited.toString()]: (
      state: DetalleSiniestroState
    ): DetalleSiniestroState => {
      return {
        ...state,
        isLoading: true,
        comentarioNuevo: false,
      };
    },
    [postSiniestroComentarioCompleted.toString()]: (
      state: DetalleSiniestroState
    ): DetalleSiniestroState => {
      return {
        ...state,
        isLoading: false,
        failed: false,
        comentarioNuevo: true,
      };
    },
    [postSiniestroComentarioFailed.toString()]: (
      state: DetalleSiniestroState
    ): DetalleSiniestroState => {
      return {
        ...state,
        isLoading: false,
        failed: true,
        comentarioNuevo: false,
      };
    },
    [closeSuccessComentarioPopUp.toString()]: (
      state: DetalleSiniestroState
    ): DetalleSiniestroState => {
      return {
        ...state,
        comentarioNuevo: false,
      };
    },
  },
  detalleSiniestroReducerInitialState
);

export { detalleSiniestroReducer };

export {
  getSiniestro,
  postSiniestroComentario,
  closeSuccessComentarioPopUp,
  clearData,
};
